import * as React from "react";
import DeviceContext from "./../../../service/indentifyDevice";
import OpLayout from "../opLayout/opLayout";
import OpQuotesMfDsk from "../opQuotes/opQuotesMf/opQuotesMfDsk";
import OpQuotesMfTab from "../opQuotes/opQuotesMf/opQuotesMfTab";
import OpQuotesMfMob from "../opQuotes/opQuotesMf/opQuotesMfMob";
import { AGetSchemeDetailsMf, AGetSchemeMf, AGetAllHoldingMf } from "./../../../service/orderPlacement/opApiService";
import { IOpRouteParamsMf } from "../../../types/components/orderPlacement/opTypes";
import { RouteChildrenProps } from "react-router-dom";

export interface IOpMfContainerProps {}

export interface IOpMfContainerState {
	quoteData: any;
	quoteDataExtra: any;
	holdingData?: any;
}

class OpMfContainer extends React.Component<IOpMfContainerProps & RouteChildrenProps<IOpRouteParamsMf>, IOpMfContainerState> {
	state: IOpMfContainerState = { quoteData: {}, quoteDataExtra: {} };
	quoteComp: any;
	// isin = this.props.match?.params.isin;
	// trdSym = this.props.match?.params.scode;
	isin = "INF209K01EN2";
	trdSym = "BSL295G-GR";

	getquoteDataRes = (res: any) => {
		if (res.PurchaseDetails) {
			this.setState({ quoteData: res.PurchaseDetails });

			// Find scheme code from data
			let scheme: any;
			res.PurchaseDetails.AscSch.LstTyp.forEach((a: any) => {
				if (scheme) {
					// if scheme is found, then no need to execute find again
					return;
				}
				const b = a.LstPlan.find((c: any) => c.Isin === this.isin && c.SchCd === this.trdSym);
				if (b) {
					scheme = b;
				}
			});
			AGetSchemeMf(this.getSchemeRes, scheme.SCd);
		}
	};

	getSchemeRes = (res: any) => {
		this.setState({ quoteDataExtra: res });
	};

	getHoldingMfRes = (res: any) => {
		if (res.data) {
			this.setState({
				holdingData: res.data.mfHdgUsable.find((hldg: any) => hldg.isin === this.isin && hldg.trdSym === this.trdSym)
			});
		}
	};

	componentDidMount() {
		AGetSchemeDetailsMf(this.getquoteDataRes, this.isin, this.trdSym);
		AGetAllHoldingMf(this.getHoldingMfRes);
	}

	render() {
		this.quoteComp = DeviceContext().isDesktop ? (
			<OpQuotesMfDsk quoteData={this.state.quoteData} quoteDataExtra={this.state.quoteDataExtra} holdingData={this.state.holdingData} />
		) : DeviceContext().isTablet ? (
			<OpQuotesMfTab quoteData={this.state.quoteData} quoteDataExtra={this.state.quoteDataExtra} holdingData={this.state.holdingData} />
		) : (
			<OpQuotesMfMob quoteData={this.state.quoteData} quoteDataExtra={this.state.quoteDataExtra} holdingData={this.state.holdingData} />
		);
		return <OpLayout quoteComp={this.quoteComp} />;
	}
}

export default OpMfContainer;
